import React from 'react';

import { timeZoneOptions, } from './shared';

import { requestPost, } from '../../../../../modules/request';
import { COLLEGE_NOT_LISTED, COLLEGE_NO_SCHOOL_SELECTED, DropdownInput, Input, INTERNATIONAL_SCHOOL_NAME, NOT_LISTED, NO_SCHOOL_SELECTED, PLACEHOLDER_SCHOOL_NAMES, US_COLLEGE_SCHOOL_TYPE, US_HIGHER_ED_SCHOOL_NAME, US_HIGHER_ED_SCHOOL_TYPE, US_K12_SCHOOL_TYPE, } from '../../../../Shared/index';
import SchoolSelector from '../../shared/school_selector';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const HOME_SCHOOL_SCHOOL_NAME = 'home school'
const OTHER_SCHOOL_NAME = 'other'

const NO_SELECTION_SCHOOL_NAMES = [HOME_SCHOOL_SCHOOL_NAME, US_HIGHER_ED_SCHOOL_NAME, INTERNATIONAL_SCHOOL_NAME, OTHER_SCHOOL_NAME, NO_SCHOOL_SELECTED, COLLEGE_NO_SCHOOL_SELECTED]
const SEARCHABLE_SCHOOL_TYPES = [US_K12_SCHOOL_TYPE, US_COLLEGE_SCHOOL_TYPE]
const DEFAULT_SCHOOL_NAME_BY_TYPE = {
  [US_K12_SCHOOL_TYPE]: NOT_LISTED,
  [US_COLLEGE_SCHOOL_TYPE]: COLLEGE_NO_SCHOOL_SELECTED,
}

export default class TeacherGeneralAccountInfo extends React.Component {
  constructor(props) {
    super(props)

    const { name, email, timeZone, school, schoolType, showDismissSchoolSelectionReminderCheckbox, } = props

    this.state = {
      name,
      email,
      school,
      timeZone,
      schoolType,
      showSchoolSelector: false,
      showButtonSection: false,
      changedSchools: false,
      schoolSelectionReminderVisible: showDismissSchoolSelectionReminderCheckbox
    }
  }

  componentDidUpdate(prevProps) {
    const { active, email, name, school, timeZone, schoolType, } = this.props

    if (prevProps.active && !active) {
      this.reset()
    }

    if (email !== prevProps.email
      || name !== prevProps.name
      || school !== prevProps.school
      || timeZone !== prevProps.timeZone
      || schoolType !== prevProps.schoolType
    ) {
      this.setState({
        email,
        name,
        school,
        timeZone,
        schoolType
      })
    }
  }

  activateSection = () => {
    if (!this.props.active || !this.state.showButtonSection) {
      this.setState({ showButtonSection: true, })
      this.props.activateSection()
    }
  };

  handleEmailChange = e => {
    this.setState({ email: e.target.value, });
  };

  handleNameChange = e => {
    this.setState({ name: e.target.value, });
  };

  handleDismissSchoolSelectionReminder = () => {
    requestPost('/milestones/complete_dismiss_school_selection_reminder')
    this.setState({ schoolSelectionReminderVisible: false, })
  }

  handleSchoolChange = (id, schoolObj) => {
    const { school } = this.state
    const { alternativeSchools, } = this.props
    if (id !== school.id) {
      this.setState({ changedSchools: true, })
      if (PLACEHOLDER_SCHOOL_NAMES.includes(id)) {
        const alternativeSchool = alternativeSchools.find(school => school.name === id)
        this.setState({ school: alternativeSchool, showSchoolSelector: false, }, () => this.handleSubmit())
      } else {
        const school = { name: schoolObj.attributes.text, id, }
        this.setState({ school, showSchoolSelector: false, })
      }
    }
  };

  handleSchoolTypeChange = schoolType => {
    const { alternativeSchools, alternativeSchoolsNameMap, } = this.props
    if (SEARCHABLE_SCHOOL_TYPES.includes(schoolType.value) && this.state.schoolType === schoolType.value) { return }

    const alternativeSchoolName = DEFAULT_SCHOOL_NAME_BY_TYPE[schoolType.value] ||
      Object.keys(alternativeSchoolsNameMap).find(key => alternativeSchoolsNameMap[key] === schoolType.value)
    const school = alternativeSchools.find(school => school.name === alternativeSchoolName)
    this.setState({ schoolType: schoolType.value, school, changedSchools: true});
  };

  handleSubmit = (e) => {
    const { name, email, timeZone, school, changedSchools } = this.state
    e?.preventDefault()
    const data = {
      name,
      email,
      time_zone: timeZone,
      school_id: school.id,
      school_options_do_not_apply: !changedSchools
    };
    this.props.updateUser(data, '/teachers/update_my_account', 'Settings saved')
  };

  handleTimezoneChange = timeZone => {
    this.setState({ timeZone: timeZone.name, });
  };

  reset = () => {
    const { email, name, timeZone, school, schoolType, } = this.props
    this.setState({
      name,
      email,
      timeZone,
      school,
      schoolType,
      showSchoolSelector: false,
      showButtonSection: false
    })
  };

  resetAndDeactivateSection = () => {
    this.reset()
    this.props.deactivateSection()
  };

  schoolTypeOptions = () => {
    const { alternativeSchoolsNameMap, schoolType, } = this.props
    return [...new Set(Object.values(alternativeSchoolsNameMap))]
      .filter(type => type !== US_HIGHER_ED_SCHOOL_TYPE || type === schoolType)
      .map(type => ({ label: type, value: type, }))
  };

  showSchoolSelector = () => {
    this.activateSection()
    this.setState({ showSchoolSelector: true, })
  };

  submitClass() {
    let buttonClass = 'quill-button contained green small focus-on-light';
    if (this.state.name === this.props.name
      && this.state.email === this.props.email
      && this.state.timeZone === this.props.timeZone
      && this.state.schoolType === this.props.schoolType
      && this.state.school === this.props.school
    ) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  renderButtonSection() {
    if (this.state.showButtonSection) {
      return (
        <div className="button-section">
          <button className="quill-button outlined grey small focus-on-light" id="cancel" onClick={this.resetAndDeactivateSection}>Cancel</button>
          <DemoGuardedButton className={this.submitClass()} onClick={this.handleSubmit}>Save changes</DemoGuardedButton>
        </div>
      )
    }
  }

  renderEmail() {
    const { provider, timesSubmitted, errors, } = this.props
    const { email, } = this.state
    if (provider) {
      return (
        <Input
          className="email external-provider bordered small"
          disabled={true}
          helperText={`Unlink your ${provider} account below to change your email.`}
          id="email"
          label="Email"
          type="text"
          value={email}
        />
      )
    } else {
      return (
        <Input
          className="email bordered small"
          error={errors.email}
          handleChange={this.handleEmailChange}
          id="email"
          label="Email"
          onClick={this.activateSection}
          timesSubmitted={timesSubmitted}
          type='text'
          value={email}
        />
      )
    }
  }

  renderSchool() {
    const { schoolType, showSchoolSelector, school, schoolSelectionReminderVisible, } = this.state
    if (!SEARCHABLE_SCHOOL_TYPES.includes(schoolType)) { return }

    const isCollege = schoolType === US_COLLEGE_SCHOOL_TYPE

    if (showSchoolSelector) {
      return (
        <SchoolSelector
          handleDismissSchoolSelectionReminder={this.handleDismissSchoolSelectionReminder}
          isCollege={isCollege}
          selectSchool={this.handleSchoolChange}
          showDismissSchoolSelectionReminderCheckbox={schoolSelectionReminderVisible}
        />
      )
    }

    const institutionNoun = isCollege ? 'institution' : 'school'
    let schoolNameValue = school && school.name ? school.name : ''
    let buttonCopy = `Change ${institutionNoun}`
    if ([NOT_LISTED, COLLEGE_NOT_LISTED].includes(schoolNameValue)) {
      schoolNameValue = 'Not listed'
    } else if (NO_SELECTION_SCHOOL_NAMES.includes(schoolNameValue)) {
      schoolNameValue = isCollege ? 'No institution selected' : 'No school selected'
      buttonCopy = `Select ${institutionNoun}`
    }
    let schoolContainerClass = "school-container"
    schoolContainerClass += schoolSelectionReminderVisible && (!school || [NO_SCHOOL_SELECTED, COLLEGE_NO_SCHOOL_SELECTED].includes(school.name)) ? ' show-notification-badges' : ''
    return (
      <div className={schoolContainerClass}>
        <div className="school-name-container">
          <label className="school-name-label">{isCollege ? 'College Institution' : 'School'}</label>
          <p className="school-name">{schoolNameValue}</p>
        </div>
        <button className="quill-button outlined small green change-school notification-badge-relative interactive-wrapper focus-on-light" onClick={this.showSchoolSelector} type="button">{buttonCopy}</button>
      </div>
    )
  }

  render() {
    const { name, timeZone, schoolType, } = this.state
    const { errors, timesSubmitted, } = this.props
    const selectedTimeZone = timeZoneOptions.find(tz => tz.name === timeZone)
    const selectedSchoolType = this.schoolTypeOptions().find(st => st.value === schoolType)

    return (
      <section aria-labelledby="generalTitle" className="user-account-general user-account-section">
        <h1 id="generalTitle">General</h1>
        <form acceptCharset="UTF-8" onSubmit={this.handleSubmit} >
          <div className="fields">
            <Input
              className="name bordered small"
              error={errors.name}
              handleChange={this.handleNameChange}
              id="full-name"
              label="Full name"
              onClick={this.activateSection}
              timesSubmitted={timesSubmitted}
              type="text"
              value={name}
            />
            {this.renderEmail()}
            <DropdownInput
              className="bordered small"
              error={errors.timeZone}
              handleChange={this.handleTimezoneChange}
              id="time-zone"
              label="Time zone"
              onClick={this.activateSection}
              options={timeZoneOptions}
              value={selectedTimeZone}
            />
            <DropdownInput
              className="bordered small"
              error={errors.schoolType}
              handleChange={this.handleSchoolTypeChange}
              id="school-type"
              label="School type"
              onClick={this.activateSection}
              options={this.schoolTypeOptions()}
              value={selectedSchoolType}
            />
            {this.renderSchool()}
          </div>
        </form>
        {this.renderButtonSection()}
      </section>
    )
  }
}
